// Imports Angular
import { Component, OnInit, ViewEncapsulation, KeyValueDiffers, ElementRef, Renderer2 } from '@angular/core';
import {Location} from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';

// Imports DIAN  
import { DLogger } from '@dian/core';
import { DFormulario, DOperacionesMatematicasServicio, DUtilidadesFormularioServicio, DTipoOperacionAritmetica, DDatosCompartidosCabecera  } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DIva300v4Servicios, DObjetoEsResponsabilidad, DObjetoPagoPrimeraCuota, DDeclaracionSugerida } from '@dian-api/iva300v4';
import { DReciboPagoDialogoServicio } from '@dian-cmp/recibo-pago';
import { DArchivoBlob } from '@dian/api-formulario';
import { DRutServicios, DActividadesEconomicas } from '@dian/api-rut';
import { DActividadEconomica } from '@dian/api-rut/src/to/actividad-economica/dactividad-economica'; 
import { DDiligenciamientoParametricasServicios, DAnticipoIvaSimple } from '@dian/api-diligenciamiento';
import { DBasicosParametricasServicios, DParametrosPolitica } from '@dian/api-basicos-parametricas';
import { DPreguntasDialogoServicio } from '@dian-cmp/preguntas';
import { DContextoUsuarioServicio } from '@dian/api-identidad';

// Imports App
import { DFormularioConfiguracion } from '../../../configuracion/dformulario-configuracion';
import { DPreguntasFormulario } from '../../../configuracion/dpreguntas-formulario';
import { DAyudasFormulario } from '../../../configuracion/dayudas-formulario';

import { DialogoDeclaSugeridaComponent } from '../../declaracion-sugerida/dialogo-decla-sugerida/dialogo-decla-sugerida.component';
import { DialogoValoresDeclaracionSugeridaComponent } from '../../declaracion-sugerida/dialogo-valores-declaracion-sugerida/dialogo-valores-declaracion-sugerida.component';
import { DialogoConsultaDeclaracionSugeridaComponent } from '../../declaracion-sugerida/dialogo-cons-decla-sugerida/dialogo-cons-decla-sugerida.component';
import { DialogoEditarDeclaracionSugeridaComponent } from './../../declaracion-sugerida/dialogo-editar-declaracion-sugerida/dialogo-editar-declaracion-sugerida.component';
import { DCasillaDocumento } from '@dian/api-diligenciamiento/src/to/dcasilla-documento';

@Component({
  selector: 'app-formulario',
  templateUrl: './formulario.component.html',
  styleUrls: ['./formulario.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    DNotificacionServicio,
    DPreguntasDialogoServicio,
    DOperacionesMatematicasServicio, 
    DUtilidadesFormularioServicio,       
    DIva300v4Servicios,
    DRutServicios,
    DDiligenciamientoParametricasServicios,
    DBasicosParametricasServicios,
    DReciboPagoDialogoServicio,
    DContextoUsuarioServicio
  ]
})
export class FormularioComponent extends DFormulario implements OnInit {
    private rutaSelector:string;
    // slide cards
    public cardDeclarante: boolean = true;   
    public cardIngresos: boolean = true;
    public cardCompras: boolean = true;
    public cardLiquidacionPrivada: boolean = true;
    public cardControlSaldos: boolean = true;
    public cardAnticiposIVA: boolean = true;
    public cardFirmas: boolean = true;
    public ayudaDeclarante: boolean = false;
    public ayudaIngresos: boolean = false;
    public ayudaCompras: boolean = false;
    public ayudaLiquidacionPrivada: boolean = false;
    public ayudaControlSaldos: boolean = false;
    public ayudaAnticiposIVA: boolean = false;
    public ayudaFirmas: boolean = false;
    public ayudasBaseFormulario: DAyudasFormulario;
    public dDatosCompartidosCabecera: DDatosCompartidosCabecera;
    public deshabilitarPeriodicidad: boolean = false;
    public esRegimenSimple:boolean = false;
    private parameters;
    public mostrarConsultarDeclaracionSugerida: boolean =false;
    public declaracionSugerida: DDeclaracionSugerida;
    public rutaRetorno: string = "WebDilIngresoFormIva300";
    public valida2025: boolean = false;
    public validaDecreto1474 : boolean = false;
    public validaCasillas2026 : boolean = false;
    public annioGravable: number;
    public limiteCas58: string = "0";
    public limiteCas59: string = "0";

    public fecha21AGO2025 = new Date(2025, 7, 21);//salvedad 21 de agosto de 2025, fecha límite para aplicar restricción del 5% y 19% a casillas 58 y 59
    public fechaPresentacion:any = new Date();
  private casConsulta:any = {
    casRespuesta: ''
  };


    /**
    * @constructor
    */
    constructor(
        dialog:MatDialog,
        router:Router,
        dNotificacionServicio:DNotificacionServicio,
        dPreguntasDialogoServicio: DPreguntasDialogoServicio,
        activatedRoute:ActivatedRoute,        
        dutilidades:DOperacionesMatematicasServicio,        
        utilitariosForm:DUtilidadesFormularioServicio,
        dlogger:DLogger,
        private dContextoUsuario: DContextoUsuarioServicio, 
        private dRutServicios:DRutServicios,         
        private dServicioRESTAPI:DIva300v4Servicios,  // Servicio de ejemplo (debe ser cambiado por el del api del formulario correspondiente),
        private dServiciosDiliParametricas:DDiligenciamientoParametricasServicios,
        private dBasicosParametricasServicios:DBasicosParametricasServicios,
        private dReciboPago: DReciboPagoDialogoServicio,
        differ: KeyValueDiffers,
      private elRef: ElementRef,
      private renderer: Renderer2,
      private _location: Location
    ) {
        super(
            router, 
            activatedRoute, 
            dialog, 
            dContextoUsuario,
            dNotificacionServicio, 
            dPreguntasDialogoServicio,
            dutilidades, 
            utilitariosForm, 
            dRutServicios, 
            dServicioRESTAPI, 
            new DFormularioConfiguracion(),
            new DPreguntasFormulario(),
            dlogger,
            differ,
            dServiciosDiliParametricas,
            dReciboPago
        );
        this.ayudasBaseFormulario = new DAyudasFormulario();  
        this.dDatosCompartidosCabecera = new DDatosCompartidosCabecera(); 
        //this.modelo.doc.cab.cs_id_1 = 2019; //Esta variable debe ser removida cuando este funcionando el documento ya que el año se obtiene del documento cargado 
    }

    /**
    * @desc Función para llamar todos los metodos que carguen los elementos del formulario
    * como tambien los datos del formulario
    */
    ngOnInit() {
      this.obtenerRutaSelector();
      setTimeout(() => {            
        this.consultarFirmanteElectronico('desconocido');      //Esta linea inicia todo el proceso de la clase abstracta
      }, 50);
        
      this.activatedRoute
          .queryParams
          .subscribe((params: Params) => {
              // si la carga no se hace por medio del metodo consultarFormulario
              if (!params.hasOwnProperty('idedocumento')) {
                  // validaciones adicionales
              } 
              //obtener parametros
              this.parameters = params;  
              if (params.hasOwnProperty('concepto')) {
                if (params['concepto']=='correccion') {
                  //obtiene fecha de presentación si es corrección cas 997 negocio 523
                  this.obtenerValorCasillaDocumento(params['documento'],300,523);
                }
                
              }
          });
    }  

    /**
    * @implements Funcion que comunica desde la clase padre que el documento se ha cargado correctamente
    */
    protected onInitFormulario() {

        this.obtenerDeclaracionSugerida();
        // Este metodo se ejecuta una vez la clase abstracta ha terminado su proceso y el formulario esta listo para ser diligenciado, aca se puede poner la logica que sea necesaria despues de que el formulario se encuentre listo                
        
        //if(!this.modelo.doc.cuerpo.hasOwnProperty('cs_id_24') || this.modelo.doc.cuerpo['cs_id_24'] == ""){
        this.obtenerPeriodicidad(); 
        /*}else{
          this.deshabilitarPeriodicidad = true;
        }
        */
        if (!this.modelo.doc.pie.hasOwnProperty('cs_id_994') || this.modelo.doc.pie['cs_id_994'] == "false") {
          this.modelo.doc.pie['cs_id_994'] = false;
        }  
        if(this.modelo.doc.cuerpo.cs_id_24 == "3"){ //Si periodicidad anual, se consultan anticipos SIMPLE
          this.esRegimenSimple = true;
          //si no es corrección
          if(this.modelo.doc.cuerpo.cs_id_25 && String(this.modelo.doc.cuerpo.cs_id_25) != "1"){
            this.consultarAnticiposIvaSimple();  
          }
        }
        this.annioGravable=Number(this.modelo.doc.cab.cs_id_1);
        if(this.annioGravable >=2025)
        {
          this.valida2025=true;
        }
        else{
          this.valida2025=false;
        }
        if((this.annioGravable ===2025) || 
          (this.annioGravable >=2026 && this.dDatosCompartidosCabecera.periodo===1 ))
          {
            this.validaDecreto1474 =false;
          }
          else{
            this.validaDecreto1474=true;
          }

          if(this.annioGravable >=2026 && this.dDatosCompartidosCabecera.periodo===1)
          {
            const mensaje1474='Si en el primer bimestre, primer cuatrimestre o en la declaración anual de 2026 obtuvo ingresos gravados por la <b>venta de juegos de suerte y azar</b> operados exclusivamente por internet, diligencie los campos así:' 
            +'<br><br>105 - ingresos gravados<br>107 - impuesto generado'
            +'<br><br>Si en el primer bimestre, el primer cuatrimestre o la declaración anual del año 2026, registró ingresos por la <b>venta de licores, aperitivos, vinos y similares</b> a la tarifa del 5 % y/o 19 %, diligencie los campos así:'
            +'<br><br>108 y 109 - ingresos'
            +'<br>110 y 111 - impuesto generado';
            const array1474 = [
              { text: 'Cerrar', value: 1, mdClass: 'primary', disabled: false },
            ];
            this.validaCasillas2026=true;
            this.dNotificacionServicio.mostrarDialogoPersonalizado("Importante", mensaje1474, "", array1474, 'primary', 'primary'); 
          }
          else
          {
            this.validaCasillas2026=false;
          }
          
    }  

    /**
    * @implements Funcion que comunica cuando el cuestionario ha sido contestado por si se requiere realizar alguna tarea adicional
    * @param {Any} respuestas
    */
    protected onInitCuestionario(respuestas:any) {            
    }

    /**
    * @implements Funcion que comunica cuando el modelo ha tenido un cambio
    * @param {Any} attrModelo
    */
    protected onChangeModelo(attrModelo:any) {
        //Implementacion de logica cuando el modelo cambia y no se ha guardado (se ocultan botones hasta que se vuelva a guardar)
        /*this.mostrarGuardarBtn = false;
        if (this.firmaRequerida) {
            this.mostrarPresentarBtn = false;  
        } else {
            this.mostrarDefinitivoBtn = false;
        }
        this.mostrarPdfBtn = false;*/           
    }

    /**
    * @implements Funcion abstracta que comunica al hijo cuando se ha ejecutado un evento sobre el formulario
    * @param {String} evento
    */
    protected eventFormulario(evento:string){
        if (!this.modelo.doc.pie.hasOwnProperty('cs_id_994') || this.modelo.doc.pie['cs_id_994'] == "false") {
          this.modelo.doc.pie['cs_id_994'] = false;
        }

      this.validarRegimenSimple();
    }

    protected onUploadFiles(docs: Array<DArchivoBlob>){

    }

    // ====== Metodos creados por el desarrollador para operaciones con casillas y otras como (validacionesEnCampos, etc) ======
    //Metodos Declaración Sugerida
    private obtenerRutaSelector() {
        //this.rutaSelector = '/WebDilGestorFormularios';
        this.dBasicosParametricasServicios.obtenerPolitica(318,"DILIGENCIAMIENTO").subscribe(
            res=>{
                let parametroPolitica = <DParametrosPolitica>res;
                this.rutaSelector = parametroPolitica.parametros[0].valor;
                //this.dlogger.info('Accion establecida con obtener ruta selector', res);
            },error=>{
                //this.dlogger.error('Error obteniendo ruta del selector', error);
            }
        );
    }    

    public dialogoDeclaracionSugerida(): void {
      let dialogConfig = new MatDialogConfig();
      dialogConfig.data = this.modelo.doc.cab.cs_id_1;
      let dialogRef = this.dialog.open(DialogoDeclaSugeridaComponent,dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        if(result){
          this.DialogoValoresDeclaSugerida(); 
        }else{
          this._location.back();
        }
      });
    } 

    public DialogoValoresDeclaSugerida():void{ 
      let dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      //dialogConfig.autoFocus = false;
      dialogConfig.data = this.declaracionSugerida;

      let dialogRef = this.dialog.open(DialogoValoresDeclaracionSugeridaComponent,dialogConfig);

      dialogRef.afterClosed().subscribe(result => {
        if(result){
          this.editarDeclaracionSugerida();
        }else{
          this.declaracionSugerida.ideAceptacion = 'N';
        }
      });
    }

    public editarDeclaracionSugerida() {
      let dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      //dialogConfig.autoFocus = false;
      dialogConfig.data = this.declaracionSugerida;      
      let dialogRef = this.dialog.open(DialogoEditarDeclaracionSugeridaComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        if(result){
          this.declaracionSugerida = result
          this.modelo.doc.cuerpo.cs_id_29 = this.declaracionSugerida.valSugeridoCasilla29;
          this.modelo.doc.cuerpo.cs_id_35 = this.declaracionSugerida.valSugeridoCasilla35;
          this.modelo.doc.cuerpo.cs_id_39 = this.declaracionSugerida.valSugeridoCasilla39;
          this.modelo.doc.cuerpo.cs_id_42 = this.declaracionSugerida.valSugeridoCasilla42;
          this.modelo.doc.cuerpo.cs_id_54 = this.declaracionSugerida.valSugeridoCasilla54;
          this.modelo.doc.cuerpo.cs_id_56 = this.declaracionSugerida.valSugeridoCasilla56;
          this.modelo.doc.cuerpo.cs_id_60 = this.declaracionSugerida.valSugeridoCasilla60;
          this.modelo.doc.cuerpo.cs_id_65 = this.declaracionSugerida.valSugeridoCasilla65;
          this.modelo.doc.cuerpo.cs_id_66 = this.declaracionSugerida.valSugeridoCasilla66;
          this.modelo.doc.cuerpo.cs_id_79 = this.declaracionSugerida.valSugeridoCasilla79;
          this.modelo.doc.cuerpo.cs_id_84 = this.declaracionSugerida.valSugeridoCasilla84;
          this.modelo.doc.cuerpo.cs_id_94 = this.declaracionSugerida.valSugeridoCasilla94;
          this.modelo.doc.cuerpo.cs_id_95 = this.declaracionSugerida.valSugeridoCasilla95;
          this.modelo.doc.cuerpo.cs_id_96 = this.declaracionSugerida.valSugeridoCasilla96;
          this.modelo.doc.cuerpo.cs_id_97 = this.declaracionSugerida.valSugeridoCasilla97;
          this.modelo.doc.cuerpo.cs_id_98 = this.declaracionSugerida.valSugeridoCasilla98;
          this.modelo.doc.cuerpo.cs_id_99 = this.declaracionSugerida.valSugeridoCasilla99;

          this.modelo.doc.cuerpo.cs_id_27 = this.declaracionSugerida.valSugeridoCasilla27;
          this.modelo.doc.cuerpo.cs_id_28 = this.declaracionSugerida.valSugeridoCasilla28;
          this.modelo.doc.cuerpo.cs_id_36 = this.declaracionSugerida.valSugeridoCasilla36;
          this.modelo.doc.cuerpo.cs_id_37 = this.declaracionSugerida.valSugeridoCasilla37;
          this.modelo.doc.cuerpo.cs_id_38 = this.declaracionSugerida.valSugeridoCasilla38;
          this.modelo.doc.cuerpo.cs_id_50 = this.declaracionSugerida.valSugeridoCasilla50;
          this.modelo.doc.cuerpo.cs_id_51 = this.declaracionSugerida.valSugeridoCasilla51;
          this.modelo.doc.cuerpo.cs_id_52 = this.declaracionSugerida.valSugeridoCasilla52;
          this.modelo.doc.cuerpo.cs_id_53 = this.declaracionSugerida.valSugeridoCasilla53;
          this.modelo.doc.cuerpo.cs_id_58 = this.declaracionSugerida.valSugeridoCasilla58;
          this.modelo.doc.cuerpo.cs_id_59 = this.declaracionSugerida.valSugeridoCasilla59;
          this.modelo.doc.cuerpo.cs_id_60 = this.declaracionSugerida.valSugeridoCasilla60;
          this.modelo.doc.cuerpo.cs_id_61 = this.declaracionSugerida.valSugeridoCasilla61;
          this.modelo.doc.cuerpo.cs_id_62 = this.declaracionSugerida.valSugeridoCasilla62;
          this.modelo.doc.cuerpo.cs_id_63 = this.declaracionSugerida.valSugeridoCasilla63;
          this.modelo.doc.cuerpo.cs_id_64 = this.declaracionSugerida.valSugeridoCasilla64;
          this.modelo.doc.cuerpo.cs_id_71 = this.declaracionSugerida.valSugeridoCasilla71;
          this.modelo.doc.cuerpo.cs_id_72 = this.declaracionSugerida.valSugeridoCasilla72;
          this.modelo.doc.cuerpo.cs_id_73 = this.declaracionSugerida.valSugeridoCasilla73;
          this.modelo.doc.cuerpo.cs_id_74 = this.declaracionSugerida.valSugeridoCasilla74;
          this.modelo.doc.cuerpo.cs_id_75 = this.declaracionSugerida.valSugeridoCasilla75;
          this.modelo.doc.cuerpo.cs_id_76 = this.declaracionSugerida.valSugeridoCasilla76;
          
          this.modelo.doc.cuerpo.cs_id_104 = this.declaracionSugerida.valSugeridoCasilla104;
          
          this.modelo.doc.cuerpo.cs_id_106 = this.declaracionSugerida.valSugeridoCasilla106;

          this.operacionCs34();
          // this.operacionCs41();//se comenta porque es llamada desde la operacionCs34()
          this.operacionCs55();
          this.operacionCs61();
          // this.operacionCs67();//se comenta porque es llamada desde la operacionCs61()
          this.operacionCs77();
          this.operacionCs100(); 
        }
      });
    }    


    operacionCs27(){
      this.modelo.doc.cuerpo.cs_id_27=this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_27,true)
    }
    operacionCs28(){
      this.modelo.doc.cuerpo.cs_id_28=this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_28,true)
    }

    public dialogoConsultaDeclaracionSugerida(): void {
      let dialogRef = this.dialog.open(
        DialogoConsultaDeclaracionSugeridaComponent, 
        {data: this.declaracionSugerida}
      );
    }  

    public validarDeclaSugeridaGuardar(){
      if (
        this.validacionesCorrectas()
      ) {
        
        
        if(this.declaracionSugerida) {
          this.asignarValoresRealesDeclaracionSugerida();
          this.actualizarDeclaracionSugerida(this.declaracionSugerida);
        }
        this.guardarActualizarBorrador();
      }
    }

    public validarDeclaSugeridaGuardarDefinitivo(){
      if(this.declaracionSugerida) {
        this.asignarValoresRealesDeclaracionSugerida(); 
        this.declaracionSugerida.ideDocumento = this.modelo.doc.cab.id;
        this.declaracionSugerida.numRepeticion = this.modelo.doc.cab.n_r;          
        this.actualizarDeclaracionSugerida(this.declaracionSugerida);
      }
      this.guardarFormularioDefinitivo();
    }

    public validarDeclaSugeridaPresentar(){
      if(this.declaracionSugerida){
        this.asignarValoresRealesDeclaracionSugerida();
        this.declaracionSugerida.ideDocumento = this.modelo.doc.cab.id;
        this.declaracionSugerida.numRepeticion = this.modelo.doc.cab.n_r;
        this.actualizarDeclaracionSugerida(this.declaracionSugerida);
      }
      this.presentarFormulario();    
    }

    private asignarValoresRealesDeclaracionSugerida(){
      //actualizar valores reales    
      this.declaracionSugerida.valRealCasilla29 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_29);
      this.declaracionSugerida.valRealCasilla35 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_35);
      this.declaracionSugerida.valRealCasilla39 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_39);
      this.declaracionSugerida.valRealCasilla42 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_42);
      this.declaracionSugerida.valRealCasilla54 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_54);
      this.declaracionSugerida.valRealCasilla56 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_56);
      this.declaracionSugerida.valRealCasilla60 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_60);
      this.declaracionSugerida.valRealCasilla65 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_65);
      this.declaracionSugerida.valRealCasilla66 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_66);
      this.declaracionSugerida.valRealCasilla79 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_79);
      this.declaracionSugerida.valRealCasilla84 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_84);
      this.declaracionSugerida.valRealCasilla94 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_94);
      this.declaracionSugerida.valRealCasilla95 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_95);
      this.declaracionSugerida.valRealCasilla96 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_96);
      this.declaracionSugerida.valRealCasilla97 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_97);
      this.declaracionSugerida.valRealCasilla98 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_98);
      this.declaracionSugerida.valRealCasilla99 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_99);
      this.declaracionSugerida.valRealCasilla27 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_27);
      this.declaracionSugerida.valRealCasilla28 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_28);
      this.declaracionSugerida.valRealCasilla36 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_36);
      this.declaracionSugerida.valRealCasilla37 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_37);
      this.declaracionSugerida.valRealCasilla38 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_38);
      this.declaracionSugerida.valRealCasilla50 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_50);
      this.declaracionSugerida.valRealCasilla51 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_51);
      this.declaracionSugerida.valRealCasilla52 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_52);
      this.declaracionSugerida.valRealCasilla53 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_53);
      this.declaracionSugerida.valRealCasilla58 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_58);
      this.declaracionSugerida.valRealCasilla59 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_59);
      this.declaracionSugerida.valRealCasilla61 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_61);
      this.declaracionSugerida.valRealCasilla62 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_62);
      this.declaracionSugerida.valRealCasilla63 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_63);
      this.declaracionSugerida.valRealCasilla64 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_64);
      this.declaracionSugerida.valRealCasilla71 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_71);
      this.declaracionSugerida.valRealCasilla72 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_72);
      this.declaracionSugerida.valRealCasilla73 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_73);
      this.declaracionSugerida.valRealCasilla74 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_74);
      this.declaracionSugerida.valRealCasilla75 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_75);
      this.declaracionSugerida.valRealCasilla76 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_76);
          
      this.declaracionSugerida.valRealCasilla104=this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_104);
          
      this.declaracionSugerida.valRealCasilla106=this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_106);

      if(!this.declaracionSugerida.ideAceptacion) this.declaracionSugerida.ideAceptacion = 'S';
    }  

    private obtenerDeclaracionSugerida(){
      let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
      this.dServicioRESTAPI.obtenerDeclaracionSugerida(
        this.modelo.doc.cab.cs_id_5,
        this.modelo.doc.cab.cs_id_1,
        this.dDatosCompartidosCabecera.periodicidad,
        this.modelo.doc.cab.cs_id_3).subscribe(
        res=>{
          this.declaracionSugerida = <DDeclaracionSugerida>res;          
          if(this.dDatosCompartidosCabecera.periodicidad != 'anual'){
            this.declaracionSugerida.valSugeridoCasilla94 = '0';
            this.declaracionSugerida.valSugeridoCasilla95 = '0';
            this.declaracionSugerida.valSugeridoCasilla96 = '0';
            this.declaracionSugerida.valSugeridoCasilla97 = '0';
            this.declaracionSugerida.valSugeridoCasilla98 = '0';
            this.declaracionSugerida.valSugeridoCasilla99 = '0';
          }
          this.mostrarConsultarDeclaracionSugerida = true;
          //Si es un borrador o un borrador con pago de primera cuota se carga el dialogo de Declaración Sugerida
          if(!this.modelo.doc.cab.cs_id_4) this.dialogoDeclaracionSugerida();             
          precargaProceso.close(); 
        }, error=>{          
          precargaProceso.close();
          //SI no devuelve nada se busca con la otra periodicidad
          let errorRes = <any>error;
          let otraPeriodicidad:string="";
          let periodoEquivalente:string="";
          if(errorRes.status == '404'){
            if(this.dDatosCompartidosCabecera.periodicidad == 'bimestral'){
              otraPeriodicidad="cuatrimestral"
              if(this.modelo.doc.cab.cs_id_3 == "2"){
                periodoEquivalente = "1";
              }else if(this.modelo.doc.cab.cs_id_3 == "4"){
                periodoEquivalente = "2";
              }else if(this.modelo.doc.cab.cs_id_3 == "6"){
                periodoEquivalente = "3";
              }
            }else if(this.dDatosCompartidosCabecera.periodicidad == 'cuatrimestral'){
              otraPeriodicidad="bimestral"
              if(this.modelo.doc.cab.cs_id_3 == "1"){
                periodoEquivalente = "2";
              }else if(this.modelo.doc.cab.cs_id_3 == "2"){
                periodoEquivalente = "4";
              }else if(this.modelo.doc.cab.cs_id_3 == "3"){
                periodoEquivalente = "6";
              }                
            }
            this.obtenerDeclaracionSugeridaOtraPeriodicidad(otraPeriodicidad, periodoEquivalente);
          }
        }
      ); 
    }

    private obtenerDeclaracionSugeridaOtraPeriodicidad(periodicidad, periodo){
      let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
      this.dServicioRESTAPI.obtenerDeclaracionSugerida(
        this.modelo.doc.cab.cs_id_5,
        this.modelo.doc.cab.cs_id_1,
        periodicidad,
        periodo).subscribe(
        res=>{
          this.declaracionSugerida = <DDeclaracionSugerida>res;
          let mensaje = `De acuerdo con la información del sistema de facturación electrónica y las responsabilidades del Registro Único Tributario, se sugiere presentar su declaración de forma ${periodicidad}, en caso de considerar que la periodicidad seleccionada si es la que le corresponde continúe con el diligenciamiento, ¿Desea continuar?`;
          const dialogoConfirmacion =this.dNotificacionServicio.mostrarDialogoConfirmacion(mensaje);
          dialogoConfirmacion.afterClosed().subscribe(
            res => {
              if(res){
                
              }else{
                //redirigir al ingreso
                window.location.href = location.origin + "/"+this.rutaRetorno;
              }
            }
          );          
          precargaProceso.close(); 
        }, error=>{          
          precargaProceso.close();
        }
      );
    }

    private actualizarDeclaracionSugerida(declaracionSugerida:any):void {
      let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
      delete declaracionSugerida['status'];
      delete declaracionSugerida['statusText'];
      this.dServicioRESTAPI.actualizarDeclaracionSugerida(
        this.modelo.doc.cab.cs_id_5, declaracionSugerida).subscribe(
        res=>{
          precargaProceso.close();
        },error=>{
          precargaProceso.close();
        }
      );
    } 

    /**
    * @desc Funcion que establece la periodicidad a partir de los parametros de la solicitud
    */
    obtenerPeriodicidad(){
      /*
      * Se establece la periodicidad en la casilla 24
      */

      let periodicidadGuardada = this.modelo.doc.cuerpo.cs_id_24;
      let periodo = this.modelo.doc.cab.cs_id_3;
      switch(this.dDatosCompartidosCabecera.periodicidad){

        case "bimestral":
          this.modelo.doc.cuerpo.cs_id_24 = "1";
          if(periodo!="1" && periodo!="2" && periodo!="3" && periodo!="4" && periodo!="5" && periodo!="6"){
            this.modelo.doc.cab.cs_id_3 = this.dDatosCompartidosCabecera.periodo;
          }
          break;

        case "cuatrimestral":
          this.modelo.doc.cuerpo.cs_id_24 = "2";
          if(periodo!="1" && periodo!="2" && periodo!="3" ){
            this.modelo.doc.cab.cs_id_3 = this.dDatosCompartidosCabecera.periodo;
          }          
          break;

        case "anual":
          this.modelo.doc.cuerpo.cs_id_24 = "3";
          if(periodo!="1"){
            this.modelo.doc.cab.cs_id_3 = this.dDatosCompartidosCabecera.periodo;
          }          
          break;          

      }

      if(this.modelo.doc.cuerpo.cs_id_24 != periodicidadGuardada){
        this.modelo.doc.cuerpo.cs_id_94 = "0";
        this.modelo.doc.cuerpo.cs_id_95 = "0";
        this.modelo.doc.cuerpo.cs_id_96 = "0";
        this.modelo.doc.cuerpo.cs_id_97 = "0";
        this.modelo.doc.cuerpo.cs_id_98 = "0";
        this.modelo.doc.cuerpo.cs_id_99 = "0";
        this.modelo.doc.cuerpo.cs_id_100 = "0";
      }
      this.deshabilitarPeriodicidad = true;      
    }
    /**
    * @desc Funcion operación casilla 34
    */
     public operacionCs34() {
      //cas41=27...+40
      const campos = ['cs_id_104','cs_id_105'];
      const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, campos,true);
      const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma, "0") ? "0" : resultadoSuma;
      const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
      this.modelo.doc.cuerpo.cs_id_34 = String(valorRedondeado); 
      this.operacionCs38();
    }
     /**
    * @desc Funcion operación casilla 38
    */
      public operacionCs38() {
        //cas41=27...+40
        const campos = ['cs_id_108','cs_id_109'];
        const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, campos,true);
        const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma, "0") ? "0" : resultadoSuma;
        const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
        this.modelo.doc.cuerpo.cs_id_38 = String(valorRedondeado); 
        this.operacionCs41();
      }
    
    /**
     * @desc Función para actualizar el límite de la casilla 58
     *       a partir del valor de la casilla 27
     */
    limitarCs58(){
      //Calcular límites para casilla 58 a partir de 5% de casilla 27 redondeado
      this.modelo.doc.cuerpo.cs_id_27=this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_27);
      this.limiteCas58=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.modelo.doc.cuerpo.cs_id_27,'0.05');
      this.limiteCas58=this.dutilidades.redondearValorMoneda(this.limiteCas58);
    }
    
    /**
     * @desc Función para actualizar el límite de la casilla 58
     *       a partir del valor de la casilla 27
    */
   limitarCs59(){
     //Calcular límites para casilla 59 a partir de 5% de casilla 28 redondeado
     this.modelo.doc.cuerpo.cs_id_28=this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_28);
      this.limiteCas59=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.modelo.doc.cuerpo.cs_id_28,'0.19');
      this.limiteCas59=this.dutilidades.redondearValorMoneda(this.limiteCas59);
    }

    /**
    * @desc Funcion operación casilla 41
    */
    public operacionCs41() {
      //cas41=27...+40
      let campos = ['cs_id_27','cs_id_28','cs_id_29','cs_id_30','cs_id_31','cs_id_32','cs_id_33','cs_id_34','cs_id_35','cs_id_36','cs_id_37','cs_id_38','cs_id_39','cs_id_40'];
      let resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, campos,true);
      let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma, "0") ? "0" : resultadoSuma;
      let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
      this.modelo.doc.cuerpo.cs_id_41 = String(valorRedondeado); 
      this.operacionCs43();
    }

    /**
    * @desc Funcion operación casilla 43
    */
    public operacionCs43() {
      //cas43=41-42
      let campos = ['cs_id_41','cs_id_42'];
      let resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.RESTA, this.modelo, campos, true);
      let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
      let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
      this.modelo.doc.cuerpo.cs_id_43 = String(valorRedondeado); 
    }

    /**
    * @desc Funcion operación casilla 55
    */
    public operacionCs55() {
      //cas55=44...+54
      let campos = ['cs_id_44','cs_id_45','cs_id_46','cs_id_47','cs_id_48','cs_id_49','cs_id_50','cs_id_51','cs_id_52','cs_id_53','cs_id_54'];
      let resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, campos, true);
      let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma, "0") ? "0" : resultadoSuma;
      let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
      this.modelo.doc.cuerpo.cs_id_55 = String(valorRedondeado); 
      this.operacionCs57();
    }

    /**
    * @desc Funcion operación casilla 57
    */
    public operacionCs57() {
      //cas57=54-55
      let campos = ['cs_id_55','cs_id_56'];
      let resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.RESTA, this.modelo, campos, true);
      let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
      let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
      this.modelo.doc.cuerpo.cs_id_57 = String(valorRedondeado); 
    }

    /**
    * @desc Funcion operación casilla 61
    */
     public operacionCs61() {
      //cas41=27...+40
      const campos = ['cs_id_106','cs_id_107'];
      const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, campos,true);
      const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma, "0") ? "0" : resultadoSuma;
      const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
      this.modelo.doc.cuerpo.cs_id_61 = String(valorRedondeado); 
      this.operacionCs64();
    }
     /**
    * @desc Funcion operación casilla 61
    */
      public operacionCs64() {
        //cas41=27...+40
        const campos = ['cs_id_110','cs_id_111'];
        const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, campos,true);
        const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma, "0") ? "0" : resultadoSuma;
        const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
        this.modelo.doc.cuerpo.cs_id_64 = String(valorRedondeado); 
        this.operacionCs67();
      }
    
    /**
    * @desc Funcion operación casilla 67
    */
    public operacionCs67() {
      //cas67=58...+66
      let campos = ['cs_id_58','cs_id_59','cs_id_60','cs_id_61','cs_id_62','cs_id_63','cs_id_64','cs_id_65','cs_id_66'];
      let resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, campos, true);
      let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma, "0") ? "0" : resultadoSuma;
      let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
      this.modelo.doc.cuerpo.cs_id_67 = String(valorRedondeado); 
      this.operacionCs81();
    }

    /**
    * @desc Funcion operación casilla 77
    */
    public operacionCs77() {
      //cas77=68...+76
      let campos = ['cs_id_68','cs_id_69','cs_id_70','cs_id_71','cs_id_72','cs_id_73','cs_id_74','cs_id_75','cs_id_76'];
      let resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, campos, true);
      let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma, "0") ? "0" : resultadoSuma;
      let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
      this.modelo.doc.cuerpo.cs_id_77 = String(valorRedondeado); 
      this.operacionCs81();
    }

    /**
    * @desc Funcion operación casilla 81
    */
    public operacionCs81() {
      //cas81=78...+80
      let campos = ['cs_id_77','cs_id_78','cs_id_79'];
      let resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, campos, true);
      let cas80 = this.modelo.doc.cuerpo.cs_id_80;
      let resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, cas80);
      let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
      let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
      this.modelo.doc.cuerpo.cs_id_81 = String(valorRedondeado); 
      this.operacionCs82();
    }

    /**
    * @desc Funcion operación casilla 82
    */
    public operacionCs82() {
      //cas82=67-81
      let campos = ['cs_id_67','cs_id_81'];
      let resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.RESTA, this.modelo, campos, true);
      let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
      let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
      this.modelo.doc.cuerpo.cs_id_82 = String(valorRedondeado); 
      this.operacionCs83();
    }

    /**
    * @desc Funcion operación casilla 83
    */
    public operacionCs83() {
      //cas83=81-67
      let campos = ['cs_id_81','cs_id_67'];
      let resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.RESTA, this.modelo, campos, true);
      let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
      let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
      this.modelo.doc.cuerpo.cs_id_83 = String(valorRedondeado); 
      this.operacionCs86();
    }

    /**
    * @desc Funcion operación casilla 86
    */
    public operacionCs86() {
      //cas86=82...-85
      let campos = ['cs_id_82','cs_id_84','cs_id_85'];
      let resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.RESTA, this.modelo, campos, true);
      let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
      let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
      this.modelo.doc.cuerpo.cs_id_86 = String(valorRedondeado); 
      this.operacionCs88();
    }

    /**
    * @desc Funcion operación casilla 88
    */
    public operacionCs88() {
      //cas88=82..-85+87
      let campos = ['cs_id_82','cs_id_87'];
      let campos2 = ['cs_id_83','cs_id_84','cs_id_85']
      let resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, campos, true);
      let resultadoSuma2 = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, campos2, true);
      let resultadoSuma3 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, resultadoSuma2, true);
      let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma3, "0") ? "0" : resultadoSuma3;
      let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
      this.modelo.doc.cuerpo.cs_id_88 = String(valorRedondeado);
      this.operacionCs89();
    }

    /**
    * @desc Funcion operación casilla 89
    */
    public operacionCs89() {
      //cas89=83..-85+85
      let camposSuma = ['cs_id_83','cs_id_84','cs_id_85'];
      let campos2 = ['cs_id_82','cs_id_87'];
      let resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
      let resultadoSuma2 = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, campos2, true);      
      let resultadoSuma3 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, resultadoSuma2, true);      
      let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma3, "0") ? "0" : resultadoSuma3;
      let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
      this.modelo.doc.cuerpo.cs_id_89 = String(valorRedondeado);
      this.operacionCs93();
    }

    /**
    * @desc Funcion operación casilla 93
    */
    public operacionCs93() {
      //cas91=87-88
      let campos = ['cs_id_89','cs_id_90'];
      let resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.RESTA, this.modelo, campos, true);
      let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
      let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
      this.modelo.doc.cuerpo.cs_id_93 = String(valorRedondeado); 
    }

    /**
    * @desc Funcion operación casilla 100
    */
    public operacionCs100() {
      //cas100=b1+...b6
      let campos = ['cs_id_94','cs_id_95','cs_id_96','cs_id_97','cs_id_98','cs_id_99'];//Cambiar por variables para bimestres (1-6)
      let resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, campos, true);
      let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma, "0") ? "0" : resultadoSuma;
      let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
      this.modelo.doc.cuerpo.cs_id_100 = String(valorRedondeado); 
    }    

    /**
    * @desc Funcion casilla 102 para obtener el DV
    */
    public obtenerDVSignatario() {
        this.modelo.doc.cuerpo.cs_id_102 = this.utilitariosForm.calcularDV(this.modelo.doc.cuerpo.cs_id_101);
    }

    public consultarAnticiposIvaSimple(){
      let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
      this.dServiciosDiliParametricas.consultarAnticiposIvaSimple(this.modelo.doc.cab.cs_id_1).subscribe(
        res=>{
            let anticipos : Array<DAnticipoIvaSimple> = <Array<DAnticipoIvaSimple>>res;
            this.modelo.doc.cuerpo.cs_id_94 = anticipos.find(anticipo=> anticipo.periodo == 1) ? String(anticipos.find(anticipo=> anticipo.periodo == 1).valIva) : "";
            this.modelo.doc.cuerpo.cs_id_95 = anticipos.find(anticipo=> anticipo.periodo == 2) ? String(anticipos.find(anticipo=> anticipo.periodo == 2).valIva) : "";
            this.modelo.doc.cuerpo.cs_id_96 = anticipos.find(anticipo=> anticipo.periodo == 3) ? String(anticipos.find(anticipo=> anticipo.periodo == 3).valIva) : "";
            this.modelo.doc.cuerpo.cs_id_97 = anticipos.find(anticipo=> anticipo.periodo == 4) ? String(anticipos.find(anticipo=> anticipo.periodo == 4).valIva) : "";
            this.modelo.doc.cuerpo.cs_id_98 = anticipos.find(anticipo=> anticipo.periodo == 5) ? String(anticipos.find(anticipo=> anticipo.periodo == 5).valIva) : "";
            this.modelo.doc.cuerpo.cs_id_99 = anticipos.find(anticipo=> anticipo.periodo == 6) ? String(anticipos.find(anticipo=> anticipo.periodo == 6).valIva) : "";
            this.operacionCs100();
            precargaProceso.close();
          },error=>{
            if(error.status!=404){
              this.dNotificacionServicio.mostrarDialogoError("Error obteniendo anticipos de IVA pagados en régimen Simple");
            }
            precargaProceso.close();
          }
      );      
    }

    public validarRegimenSimple(){
      for(let i=94; i<100; i++){
        let casillaElemento = document.querySelector('#cs_id_'+i);
        if(this.esRegimenSimple){        
          casillaElemento.removeAttribute('disabled');
        }else{
          casillaElemento.setAttribute('disabled', 'true');
        }
      }
    }        

public validacionesCorrectas() {
  let valoresEnCero = false;
  let cantidadValoresCero = 0;
  let sugerencias = '';
  this.limitarCs58();
  this.limitarCs59();

  const c = this.modelo.doc.cuerpo;

  const val = (id: string) => this.dutilidades.redondearValorMoneda(c[`cs_id_${id}`], true);

  const arrayButtons = [
    { text: 'Volver', value: 1, mdClass: 'primary', disabled: false },
  ];


  const agregarSugerencia = (mensaje: string): boolean => {
    sugerencias += mensaje+'<br>';
    valoresEnCero = true;
    cantidadValoresCero++;
    return true;
  };

  // Validaciones de porcentaje de interés
  if (this.parameters.hasOwnProperty('concepto')) {
    if (this.parameters['concepto'] == 'correccion') {
      if (this.fechaPresentacion >= this.fecha21AGO2025) {
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, val("58"), this.limiteCas58)) {
          this.dNotificacionServicio.mostrarDialogoPersonalizado("Mensaje", "Verifique el valor de la casilla 58, ya que este supera el valor de la tarifa del 5%", "", arrayButtons, 'primary', 'primary');
          // return false;
        }

        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, val("59"), this.limiteCas59)) {
          this.dNotificacionServicio.mostrarDialogoPersonalizado("Mensaje", "Verifique el valor de la casilla 59, ya que este supera el valor de la tarifa del 19%", "", arrayButtons, 'primary', 'primary');
          // return false;
        }
      }

      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, val("58"), this.limiteCas58)) {
        this.dNotificacionServicio.mostrarDialogoPersonalizado("Mensaje", "Verifique el valor de la casilla 58, ya que este es inferior al valor de la tarifa del 5%", "", arrayButtons, 'primary', 'primary');
        // return false;
      }

      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, val("59"), this.limiteCas59)) {
        this.dNotificacionServicio.mostrarDialogoPersonalizado("Mensaje", "Verifique el valor de la casilla 59, ya que este es inferior al valor de la tarifa del 19%", "", arrayButtons, 'primary', 'primary');
        // return false;
      }


    }
    else{
      //validaciones bloqueantes cuando no es corrección
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, val("58"), this.limiteCas58)) {
          this.dNotificacionServicio.mostrarDialogoPersonalizado("Mensaje", "Verifique el valor de la casilla 58, ya que este supera el valor de la tarifa del 5%", "", arrayButtons, 'primary', 'primary');
          return false;
        }

        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, val("59"), this.limiteCas59)) {
          this.dNotificacionServicio.mostrarDialogoPersonalizado("Mensaje", "Verifique el valor de la casilla 59, ya que este supera el valor de la tarifa del 19%", "", arrayButtons, 'primary', 'primary');
          return false;
        }
      

      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, val("58"), this.limiteCas58)) {
        this.dNotificacionServicio.mostrarDialogoPersonalizado("Mensaje", "Verifique el valor de la casilla 58, ya que este es inferior al valor de la tarifa del 5%", "", arrayButtons, 'primary', 'primary');
        // return false;
      }

      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, val("59"), this.limiteCas59)) {
        this.dNotificacionServicio.mostrarDialogoPersonalizado("Mensaje", "Verifique el valor de la casilla 59, ya que este es inferior al valor de la tarifa del 19%", "", arrayButtons, 'primary', 'primary');
        // return false;
      }
    }
  }
  // reglas suprimidas por inconveniencia cuando los valores en la primera casilla son demasiado pequeñas
  // Reglas tipo: si A > 0 y B <= 0, mostrar error
  const reglas = [
    { a: "27", b: "58", casilla: "58" },
    { a: "28", b: "59", casilla: "59" },
    { a: "29", b: "60", casilla: "60" },
    { a: "34", b: "61", casilla: "61" },
    { a: "104", b: "106", casilla: "106" },
    { a: "105", b: "107", casilla: "107" },
    { a: "36", b: "62", casilla: "62" },
    { a: "37", b: "63", casilla: "63" },
    { a: "38", b: "64", casilla: "64" },
  ];

  for (const regla of reglas) {
    if (
      this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, val(regla.a), "0") &&
      this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, val(regla.b), "0")
    ) {
      agregarSugerencia(`Verifique el valor de la casilla ${regla.casilla}, ya que debe ser mayor a 0.`);
    }
  }
if (valoresEnCero) {
      this.dNotificacionServicio.mostrarDialogoPersonalizado("Mensaje", sugerencias, "", arrayButtons, 'primary', 'primary');
}
  return true;
}

//https://apipruebasfuncionales.dian.gov.co/diligenciamiento/parametricas/v1/valoresOcurrenciasCasillasdoc/2604601016586?ideFormato=300&casillasNegocio=523
  obtenerValorCasillaDocumento(ideDocumento: string, formato: number, casilla: number) {

    this.dServiciosDiliParametricas.obtenerValorCasillaDoc(ideDocumento, formato, casilla).subscribe(
      res => {
        let objetoCasillaDocumento = <DCasillaDocumento>res

        let valorFecha = objetoCasillaDocumento.casillas[0].valorCasilla.valor;
              // Validar si la fecha es nula, vacía o indefinida
      if (!valorFecha || valorFecha.trim() === '') {
        this.fechaPresentacion = new Date(); // Fecha actual
      } else {
        this.fechaPresentacion = this.convertirAFecha(valorFecha);
      }

      console.log('Fecha de presentación: ' + this.fechaPresentacion.toString());
      }, error => {
        console.log("No se ha podido consultar el valor de la casilla fecha de presentación");
      }
    );
  }
 

convertirAFecha(fechaStr: string): Date {
  const year = parseInt(fechaStr.slice(0, 4), 10);
  const month = parseInt(fechaStr.slice(4, 6), 10) - 1; // Mes 0-indexado
  const day = parseInt(fechaStr.slice(6, 8), 10);
  const hour = parseInt(fechaStr.slice(8, 10), 10);
  const minute = parseInt(fechaStr.slice(10, 12), 10);
  const second = parseInt(fechaStr.slice(12, 14), 10);

  return new Date(year, month, day, hour, minute, second);
}

}



// WEBPACK FOOTER //
// D:/GIT/F300/V4/ng_formulario300v4/src/app/components/formulario/formulario/formulario.component.ts